import { INPUT_FIELD_NAMES } from "nlib/common/ContactForm/constants";
import Input from "nlib/ui/Input";
import React from "react";
import useContactFormContext from "nlib/common/ContactForm/useContactFormContext";

const ContactFormZipCodeInput = (props) => {
  const { value, disabled, readOnly, onChange } = useContactFormContext(INPUT_FIELD_NAMES.ZIP_CODE);

  return (
    <Input
      placeholder="000000"
      {...props}
      disabled={disabled}
      readOnly={readOnly}
      value={value || ""}
      onChange={onChange} />
  );
};

export default React.memo(ContactFormZipCodeInput);
